<!-- Responsibility: Admin USERS tab - Governance and invitations.
Scope: Permissions, Testers, and Invite logic. -->
<admin-users-tab>
  <div class="admin-tab-content">
    <div class="admin-grid">
      <admin-permission-card
        is-supreme-admin={ props.state.isSupremeAdmin }
        supreme-email={ props.state.supremeEmail }
        role-grants={ props.state.roleGrants }
        principal-name={ props.helpers.principalName }
        principal-handle={ props.helpers.principalHandle }
        format-role={ props.helpers.formatRole }
        format-time={ props.helpers.formatTime }
        on-quick-set-role={ props.onQuickSetRole }
      ></admin-permission-card>

      <admin-tester-card
        tester-grants={ props.state.testerGrants }
        principal-name={ props.helpers.principalName }
        principal-handle={ props.helpers.principalHandle }
        tester-grant-label={ props.helpers.testerGrantLabel }
        format-time={ props.helpers.formatTime }
        on-revoke-tester-grant={ props.onRevokeTesterGrant }
      ></admin-tester-card>

      <admin-invite-card
        sending-invite={ props.state.sendingInvite }
        invite-message={ props.state.inviteMessage }
        on-send-invite={ props.onSendInvite }
      ></admin-invite-card>
    </div>
  </div>

  <script>
    import AdminPermissionCard from './admin-permission-card.riot'
    import AdminTesterCard from './admin-tester-card.riot'
    import AdminInviteCard from './admin-invite-card.riot'

    export default {
      components: {
        AdminPermissionCard, AdminTesterCard, AdminInviteCard
      }
    }
  </script>

  <style>
    .admin-tab-content { display: grid; gap: var(--space-lg); }
    .admin-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(350px, 1fr)); gap: var(--space-lg); }
  </style>
</admin-users-tab>
